<div class="container-fluid mt-3">
  <h2 class="text-center mb-3">{{ currentEditId ? 'Update Counsellor MOM Session' : 'Add Counsellor MOM Session' }}</h2>

  <form [formGroup]="momForm" class="row" autocomplete="off">
    <!-- Session Date -->

      <mat-form-field appearance="outline"  class="col-md-4 col-sm-4 mb-3">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" placeholder="Select date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="momForm.get('date')?.hasError('required')">
          Date is required
        </mat-error>
      </mat-form-field>


    <app-searchable-select
      class="col-md-8 col-sm-8"
      [multiple]="true"
      [options]="filteredCounsellors"
      [selectedValue]="momForm.get('participants')?.value"
      [displayWithFn]="displayCentre"
      [placeholder]="'Select Participants'"
      [label]="'Select Participants'"
      (selectionChange)="onParticipantsChange($event)">
    </app-searchable-select>


    <!-- Participants Field with Multi-Select -->
<!--    <mat-form-field appearance="outline" class="col-md-8 col-sm-8">-->
<!--      <mat-label>Select Participants</mat-label>-->
<!--      <mat-select-->
<!--        multiple-->
<!--        formControlName="participants"-->
<!--        aria-label="Select Participants"-->
<!--        (openedChange)="onParticipantDropdownOpened($event)"-->
<!--        #participantSelect="matSelect">-->

<!--        &lt;!&ndash; Trigger display &ndash;&gt;-->
<!--        <mat-select-trigger>-->
<!--      <span *ngIf="participantSelect.value?.length; else noParticipantSelection">-->
<!--        {{ participantSelect.value[0] | slice:0:25 }}-->
<!--        {{ participantSelect.value[0]?.length > 25 ? '...' : '' }}-->
<!--        <span *ngIf="participantSelect.value.length > 1" class="textcol">-->
<!--          (+{{ participantSelect.value.length - 1 }} more)-->
<!--        </span>-->
<!--      </span>-->
<!--          <ng-template #noParticipantSelection>-->
<!--            Select Participants...-->
<!--          </ng-template>-->
<!--        </mat-select-trigger>-->

<!--        &lt;!&ndash; Search box &ndash;&gt;-->
<!--        <div class="mat-select-search" style="padding: 8px;">-->
<!--          <input-->
<!--            type="text"-->
<!--            placeholder="Search participant..."-->
<!--            [(ngModel)]="participantSearch"-->
<!--            [ngModelOptions]="{standalone: true}"-->
<!--            (ngModelChange)="filterParticipants()"-->
<!--            (click)="$event.stopPropagation()"-->
<!--            (keydown)="$event.stopPropagation()"-->
<!--            class="employee-search-input w-100 p-0 border rounded"-->
<!--            autocomplete="off"-->
<!--          />-->
<!--        </div>-->

<!--        &lt;!&ndash; Participant options &ndash;&gt;-->
<!--        <mat-option *ngFor="let counsellor of filteredCounsellors" [value]="counsellor">-->
<!--          {{ counsellor }}-->
<!--        </mat-option>-->
<!--      </mat-select>-->
<!--      <mat-error *ngIf="momForm.get('participants')?.hasError('required')">-->
<!--        Participants are required-->
<!--      </mat-error>-->
<!--    </mat-form-field>-->

    <!-- Topic -->
<!--    <mat-form-field appearance="outline" class="col-md-12 col-sm-12">-->
<!--      <mat-label>Topic</mat-label>-->
<!--      <input matInput formControlName="topic"/>-->
<!--      <mat-error *ngIf="momForm.get('topic')?.hasError('required')">-->
<!--        Topic is required-->
<!--      </mat-error>-->
<!--    </mat-form-field>-->

    <!-- Session Items Table Section -->
    <div class="col-12 mt-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4>Session Items</h4>
        <button type="button" mat-raised-button color="accent" (click)="addSessionRow()">
          <mat-icon>add</mat-icon>
          Add
        </button>
      </div>

      <div class="table-container mat-elevation-z2">
        <table mat-table [dataSource]="sessionDataSource" class="w-100">

          <!-- Topic Column -->
          <ng-container matColumnDef="topic">
            <th mat-header-cell *matHeaderCellDef>Topic</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
              <mat-form-field appearance="outline" class="w-100">
                                      <textarea
                                        matInput
                                        formControlName="topic"
                                        placeholder="Enter topic"
                                        rows="2">
      </textarea>
                <mat-error *ngIf="element.get('topic')?.hasError('required')">
                  Required
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Discussion Summary Column -->
          <ng-container matColumnDef="discussionSummary">
            <th mat-header-cell *matHeaderCellDef>Discussion Summary *</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
              <mat-form-field appearance="outline" class="w-100">
                <textarea matInput formControlName="discussionSummary"
                          placeholder="Enter discussion summary" rows="2"></textarea>
                <mat-error *ngIf="element.get('discussionSummary')?.hasError('required')">
                  Required
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Person In-Charge Column -->

          <!-- Person In-Charge Column -->
          <ng-container matColumnDef="personInCharge">
            <th mat-header-cell *matHeaderCellDef>Person In-Charge *</th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
              <mat-form-field appearance="outline" class="w-100">
                <mat-select
                  formControlName="personInCharge"
                  multiple
                  (openedChange)="onPersonInChargeDropdownOpened($event)"
                  (selectionChange)="onPersonInChargeSelectionChange($event, i)">

                  <!-- Custom Trigger Display -->
                  <mat-select-trigger>
                    <ng-container *ngIf="getSelectedPersonInCharge(i)?.length; else noPersonInCharge">
                      {{ getSelectedPersonInCharge(i).slice(0, 1).join(', ') }}

                      <span
                        *ngIf="getSelectedPersonInCharge(i).length > 1"
                        class="read-more"
                        (click)="togglePersonInChargeReadMore($event, i)">
              {{ showAllPersonInCharge[i]
                        ? ' (Show less)'
                        : ' +' + (getSelectedPersonInCharge(i).length - 1) + ' more' }}
            </span>

                      <span *ngIf="showAllPersonInCharge[i]">
              , {{ getSelectedPersonInCharge(i).slice(1).join(', ') }}
            </span>
                    </ng-container>

                    <ng-template #noPersonInCharge>
                      Select Person In-Charge
                    </ng-template>
                  </mat-select-trigger>

                  <!-- Search Input -->
                  <div class="mat-select-search" style="padding: 8px;">
                    <input
                      type="text"
                      placeholder="Search person..."
                      (input)="onSearchPersonInChargeChange($event, i)"
                      (click)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()"
                      class="w-100 p-1 border rounded"
                      autocomplete="off"
                    />
                  </div>

                  <!-- None Option -->
                  <mat-option
                    value="None"
                    [disabled]="isNoneDisabled(i)">
                    None
                  </mat-option>

                  <!-- Options (show filtered or all) -->
                  <mat-option
                    *ngFor="let counsellor of (personInChargeSearch ? filteredPersonInCharge : allCounsellors)"
                    [value]="counsellor"
                    [disabled]="isPersonInChargeDisabled(i)">
                    {{ counsellor }}
                  </mat-option>

                </mat-select>
                <mat-error *ngIf="element.get('personInCharge')?.hasError('required')">
                  Required
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <button type="button" mat-icon-button color="warn"
                      (click)="removeSessionRow(i)" matTooltip="Remove">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- No Data Row -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center py-3" [attr.colspan]="displayedColumns.length">
              <p class="text-muted">No session items added. Click "Add Session Item" to begin.</p>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <mat-form-field *ngIf="userData === 'Krisha Shah' || userData === 'Vaishali Nanda'" appearance="outline" class="col-md-12">
      <mat-label>Remarks</mat-label>
      <textarea matInput rows="2" formControlName="remarks"></textarea>
    </mat-form-field>

    <!-- Action Buttons -->
    <div class="col-12 d-flex justify-content-end gap-2 mt-4">
      <button
        type="button"
        mat-raised-button
        (click)="cancel()"
        [disabled]="isLoading">
        Cancel
      </button>
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="submitForm()"
        [disabled]="momForm.invalid || isLoading">
        <span *ngIf="!isLoading">{{ currentEditId ? 'Update' : 'Save' }}</span>
        <span *ngIf="isLoading">Processing...</span>
      </button>
    </div>
  </form>
</div>

